function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*jshint esversion: 8 */
var authConfigurationCache = null;
export var Configuration = /*#__PURE__*/function () {
  function Configuration() {
    _classCallCheck(this, Configuration);

    this.SCRIPT_NAME = "/dist/MPWidgets.";
  }

  _createClass(Configuration, [{
    key: "GetAuthConfiguration",
    value: function GetAuthConfiguration(useCacheIfAvailable) {
      if (useCacheIfAvailable === true && authConfigurationCache != null) {
        return Promise.resolve(authConfigurationCache);
      }

      var appRoot = this.GetAppRoot();

      if (appRoot === "") {
        return;
      }

      var url = "".concat(appRoot, "/Api/Auth");
      return fetch(url).then(function (authInfo) {
        return authInfo.json().then(function (authConfiguration) {
          authConfigurationCache = authConfiguration;
          return authConfiguration;
        });
      }, function (err) {
        console.error("Unable to retrieve auth info!");
        console.error(err);
        throw new Error(err);
      });
    }
  }, {
    key: "GetAuthToken",
    value: function GetAuthToken(cacheKey) {
      var appRoot = this.GetAppRoot();
      var url = "".concat(appRoot, "/Home/Tokens?cacheKey=").concat(cacheKey);
      return fetch(url).then(function (authInfo) {
        return authInfo.json();
      }, function (err) {
        console.error("Unable to retrieve auth token!");
        console.error(err);
        throw new Error(err);
      });
    }
  }, {
    key: "GetCSRFToken",
    value: function GetCSRFToken() {
      var appRoot = this.GetAppRoot();
      var url = "".concat(appRoot, "/Home/CSRFToken");
      return fetch(url).then(function (authInfo) {
        return authInfo.json();
      }, function (err) {
        console.error("Unable to retrieve CSRF token!");
        console.error(err);
        throw new Error(err);
      });
    }
  }, {
    key: "GetAppRoot",
    value: function GetAppRoot() {
      //if (sessionStorage.appRoot) {
      //	return sessionStorage.appRoot;
      //} else {
      //Find base URL of main components script and put it into session storage:
      if (document.getElementById("MPWidgets") !== null && document.getElementById("MPWidgets") !== undefined) {
        var currentScriptSrc = document.getElementById("MPWidgets").src;

        if (currentScriptSrc) {
          var appRoot = currentScriptSrc.substring(0, currentScriptSrc.indexOf(this.SCRIPT_NAME));
          sessionStorage.appRoot = appRoot;
          return appRoot;
        } else {
          // eslint-disable-next-line no-console
          console.log("Error: Could not find script in header of page with id='MPWidgets'");
        }
      } // }

    }
  }, {
    key: "GetConfigurationSetting",
    value: function GetConfigurationSetting(keyName) {
      return fetch("".concat(this.GetAppRoot(), "/Api/ConfigurationApi/GetConfigurationSettingValue?keyName=").concat(keyName)).then(function (response) {
        return response.text();
      });
    }
  }, {
    key: "GetGlobalConfigurationSettingValues",
    value: function () {
      var _GetGlobalConfigurationSettingValues = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(keyName) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch("".concat(this.GetAppRoot(), "/Api/ConfigurationApi/GetGlobalConfigurationSettingValues")).then(function (response) {
                  return response.json();
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetGlobalConfigurationSettingValues(_x) {
        return _GetGlobalConfigurationSettingValues.apply(this, arguments);
      }

      return GetGlobalConfigurationSettingValues;
    }()
  }, {
    key: "GetCustomStyles",
    value: function GetCustomStyles() {
      return fetch("".concat(this.GetAppRoot(), "/Api/ConfigurationApi/GetCustomStyles")).then(function (response) {
        return response.json();
      });
    }
  }, {
    key: "GetLocalCountryCode",
    value: function GetLocalCountryCode(countryList) {
      var result = "US";

      if (!!window.navigator && !!countryList && !!countryList.length) {
        var locale = window.navigator.language || result;
        var localeParts = locale.split("-");
        var countryCode = localeParts[localeParts.length - 1];
        var matches = countryList.filter(function (country) {
          return country.abbreviation == countryCode;
        });

        if (!!matches && matches.length > 0) {
          result = countryCode;
        }
      }

      return result;
    }
  }, {
    key: "GetSiteInfo",
    value: function GetSiteInfo() {
      var appRoot = this.GetAppRoot();
      var url = "".concat(appRoot, "/api/ConfigurationApi/GetSiteInfo");
      return fetch(url).then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch site info');
        }

        return response.json();
      }).then(function (data) {
        if (_typeof(data) !== 'object' || data === null) {
          throw new Error('Invalid site info data');
        }

        return data;
      })["catch"](function () {
        return {};
      });
    }
  }]);

  return Configuration;
}();
export var ConfigurationService = new Configuration();